// test677
(677 && 0);
